module.exports = __webpack_public_path__ + "img/852.58a85557.png";